import DOMPurify from "isomorphic-dompurify";

export function sanitizeHTML(dirtyHTML) {
  return DOMPurify.sanitize(dirtyHTML, {
    ALLOWED_TAGS: [
      "b", "i", "em", "strong", "p", "br", "span", "ul", "ol", "li", "a"
    ],
    ALLOWED_ATTR: [
      "style", "href", "target", "rel"
    ],
    FORBID_TAGS: ["script", "iframe", "object", "embed"],
    ALLOW_ARIA_ATTR: true,
    ALLOW_DATA_ATTR: false
  });
}